import { AjustedVariant } from "@modules/products/templates";
import { FieldInputProps, FormikProps } from "formik";

type handleAmountSelectionProps = {
  item: AjustedVariant;
  field: FieldInputProps<any>;
  form: FormikProps<any>;
}

export const handleAmountSelection = (props: handleAmountSelectionProps) => {
  const { item, field, form } = props;
  form.setFieldValue(field.name, item)
}
